export default {
    setConnectorsData(state, data) {
        state.connectorsData = {
            ...state.connectorsData,
            ...data,
        };
    },
};
